import { DEFAULT_LOCALE } from "~/constants/locale";
import { LOCALE } from "~/constants/storage";
import { LanguageKey } from "~/types/language";

export const getLocale = () =>
  (localStorage.getItem(LOCALE) as LanguageKey) || DEFAULT_LOCALE;
